import { Stack, Tab, Tabs, Typography } from '@mui/material';
import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import {
	DATA_AUTOFILL_LABEL,
	EXTERNAL_RATER_LABEL,
	MANAGE_INTEGRATIONS_HEADER,
	WEBHOOK_LABEL,
} from '../../data/constants';

export default function Integrations() {
	const { pathname } = useLocation();
	const route = pathname.split('/').pop();
	return (
		<Stack direction='column' height='100%' spacing={2}>
			<Typography variant='h3'>{MANAGE_INTEGRATIONS_HEADER()}</Typography>
			<Tabs value={route}>
				<Tab
					label={EXTERNAL_RATER_LABEL(true)}
					id={`Tabs__Tab--${EXTERNAL_RATER_LABEL(true)}`}
					to={'external-raters'}
					value={'external-raters'}
					component={NavLink}
				/>
				<Tab
					label={DATA_AUTOFILL_LABEL(true)}
					id={`Tabs__Tab--${DATA_AUTOFILL_LABEL(true)}`}
					to={'data-autofills'}
					value={'data-autofills'}
					component={NavLink}
				/>
				<Tab
					label={WEBHOOK_LABEL(true)}
					id={`Tabs__Tab--${WEBHOOK_LABEL(true)}`}
					to={'webhooks'}
					value={'webhooks'}
					component={NavLink}
				/>
			</Tabs>
			<Outlet />
		</Stack>
	);
}
